import { FileMeta } from '/imports/types';
import { DeclareMethod } from '/imports/methods';

export const startFileUpload = DeclareMethod<{ name: string, type: string, size: number }, string>('startFileUpload');
export const uploadFileChunk = DeclareMethod<{ token: string, chunk: string }>('uploadFileChunk');
export const finishFileUpload = DeclareMethod<string, FileMeta>('finishFileUpload');